export providerContentReducer = (state = [], action) ->
  switch action.type
    when 'CHANGE_GROUP_SUCCESS'
      if action.updatedState?.providerContent then action.updatedState.providerContent else state
    else
      state
